// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";

export class MenuState {
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "UserDefinedConfiguration" as const,
    });
    static readonly __type = 'Orders.MenuState';
    private static valuePromise?: Promise<MenuState.ValueType>;

    static get(): Promise<MenuState.ValueType> {
        if (!this.valuePromise) {
            this.valuePromise = ExecutionService.executeMethodAndReturnData<MenuState.ValueType>('UserDefinedConfiguration', 'Orders', 'MenuState', undefined, 'get', [])
        }

        return this.valuePromise
    }

    static async set(value: MenuState.ValueType): Promise<void> {
        this.valuePromise = Promise.resolve(value)
        await ExecutionService.executeMethodAndReturnData<MenuState.ValueType>('UserDefinedConfiguration', 'Orders', 'MenuState', undefined, 'set', [value])
    }
}

export namespace MenuState {
    export type ValueType = any
}
